import widgetTemplatesAPI from '@api/templates'

export default {
  namespaced: true,
  state: () => ({
    baseTemplates: [],       // initially empty; will be loaded from the API
    selectedTheme: 'DEFAULT', // 'DEFAULT' represents the base theme
    loadingTemplates: false, // NEW: track if templates are loading
  }),
  getters: {
    selectedTheme(state) {
      return state.selectedTheme
    },
    getWidgetTemplateByID: (state, getters) => (templateID) => {
      const foundTemplate = getters.allTemplatesForSelectedTheme.find(
        (template) => template.id === templateID,
      )
      if (!foundTemplate) {
        console.warn(`Template with ID ${templateID} not found.`)
        return null
      }
      foundTemplate.template_id = templateID

      return foundTemplate
    },
    allTemplatesForSelectedTheme(state) {
      if (state.selectedTheme === 'DEFAULT') {
        return state.baseTemplates.filter(template =>
          template.template_theme === 'default',
        )
      }
      const templateMap = {}
      state.baseTemplates.forEach(template => {
        const key = template.template_id || template.name
        if (template.template_theme === 'default') {
          templateMap[key] = template
        }
      })
      state.baseTemplates.forEach(template => {
        const key = template.template_id || template.name
        if (template.template_theme === state.selectedTheme.toLowerCase()) {
          templateMap[key] = template
        }
      })
      return Object.values(templateMap)
    },
    sortedTemplatesForSelectedTheme(state, getters) {
      const templatesArray = getters.allTemplatesForSelectedTheme.slice()
      templatesArray.sort((a, b) => {
        const priorityA = a.priority !== undefined ? a.priority : Infinity
        const priorityB = b.priority !== undefined ? b.priority : Infinity
        return priorityA - priorityB
      })
      return templatesArray
    },
    loadingTemplates(state) {
      return state.loadingTemplates
    },
  },
  mutations: {
    SET_SELECTED_THEME(state, themeName) {
      state.selectedTheme = themeName
    },
    SET_BASE_TEMPLATES(state, templates) {
      state.baseTemplates = templates
    },
    SET_LOADING_TEMPLATES(state, isLoading) {
      state.loadingTemplates = isLoading
    },
  },
  actions: {
    setSelectedTheme({ commit, dispatch }, themeName) {
      commit('SET_SELECTED_THEME', themeName)
      dispatch('fetchTemplatesByTheme', themeName)
    },
    fetchTemplatesByTheme({ commit }, themeName) {
      // Start loading
      commit('SET_LOADING_TEMPLATES', true)
      const filter = themeName.toLowerCase()
      return widgetTemplatesAPI.getAllWidgetTemplates(
        { template_theme: filter })
        .then((response) => {
          commit('SET_BASE_TEMPLATES', response.data)
        })
        .catch((error) => {
          console.error('Error fetching widget templates for theme:', themeName,
            error)
        })
        .finally(() => {
          commit('SET_LOADING_TEMPLATES', false)
        })
    },
    fetchBaseTemplates({ commit }) {
      commit('SET_LOADING_TEMPLATES', true)
      return widgetTemplatesAPI.getAllWidgetTemplates(
        { template_theme: 'default' })
        .then((response) => {
          commit('SET_BASE_TEMPLATES', response.data)
        })
        .catch((error) => {
          console.error('Error fetching default widget templates:', error)
        })
        .finally(() => {
          commit('SET_LOADING_TEMPLATES', false)
        })
    },
    updateWidgetTemplate({ dispatch }, { templateID, data }) {
      // templateID: the id of the template to update.
      return widgetTemplatesAPI.updateWidgetTemplate(templateID, data)
        .then((response) => {
          // Optionally refresh the list or update state accordingly.
          dispatch('fetchTemplatesByTheme', this.state.templates.selectedTheme)
          return response
        })
        .catch((error) => {
          console.error('Error updating widget template:', error)
          throw error
        })
    },
    createWidgetTemplate({ dispatch }, data) {
      return widgetTemplatesAPI.createWidgetTemplate(data)
        .then((response) => {
          // Optionally refresh the list or update state accordingly.
          dispatch('fetchTemplatesByTheme', this.state.templates.selectedTheme)
          return response
        })
        .catch((error) => {
          console.error('Error creating widget template:', error)
          throw error
        })
    },
  },
}